import { render, staticRenderFns } from "./RenameDocModal.vue?vue&type=template&id=67a7153f&"
import script from "./RenameDocModal.vue?vue&type=script&lang=js&"
export * from "./RenameDocModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a7153f')) {
      api.createRecord('67a7153f', component.options)
    } else {
      api.reload('67a7153f', component.options)
    }
    module.hot.accept("./RenameDocModal.vue?vue&type=template&id=67a7153f&", function () {
      api.rerender('67a7153f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/viewKnowledge/documents/components/RenameDocModal.vue"
export default component.exports